/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { datadogRum } from '@datadog/browser-rum';
import { Provider } from 'react-redux';

import { OpenAPI } from 'core/api';
import { API_URL, SENTRY_URL } from 'core/constants';
import ENVIRONMENT from 'core/environment';

import { Root } from 'pages/root';
import RejectOfferPage from 'pages/RejectWaitlistOfferPage/RejectWaitlistOfferPage';
import ExpiredWaitlistOfferPage from 'pages/ExpiredWaitlistOfferPage/ExpiredWaitlistOfferPage';

import { store } from './state/store';
import '@teamsnap/snap-ui/build/snap-ui.min.css';
import '@teamsnap/teamsnap-ui/src/css/teamsnap-ui.scss';
import './core/css/root.scss';
import NotFound from 'pages/NotFound';
import { ampli } from 'core/ampli';
import { Cookies } from 'components/Cookies';

OpenAPI.BASE = API_URL;
OpenAPI.WITH_CREDENTIALS = true;

window.onload = async () => {
  // @ts-ignore
  if (ENVIRONMENT === 'local' || window?.location?.host?.includes('localhost')) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_URL,
    environment: ENVIRONMENT,
    ignoreErrors: [
      // We are ignoring ResizeObserver loop limit exceeded errors because they are not actionable and are not causing any issues.
      // They stem from use of a 3rd-party widget.
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });

  datadogRum.init({
    applicationId: '410c3c7c-c4a4-4c4e-b5f3-3fe8af6ca818',
    clientToken: 'pube6102c833049e8a800dd4dd3070de45e',
    site: 'datadoghq.com',
    service: 'order-frontend',
    env: ENVIRONMENT,
    version: '1.0.0',
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
  });

  ampli.load({
    // @ts-ignore
    environment: ENVIRONMENT === 'prod'
      ? 'prodteamsnapforbusiness'
      : 'devteamsnapforbusiness',
    client: { configuration: { defaultTracking: false } },
  });
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/order/:orderId" element={<Root />} />
          <Route path="/order/:orderId/:path" element={<Root />} />
          <Route path="/accept/:offerToken" element={<Root />} />
          <Route path="/accept/:offerToken/:path" element={<Root />} />
          <Route path="/decline/:offerToken" element={<Root />} />
          <Route path="/decline/:offerToke/:path" element={<Root />} />
          <Route path="/reject" element={<RejectOfferPage />} />
          <Route path="/expired" element={<ExpiredWaitlistOfferPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Cookies />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
